import { UserBehaviorAnalytics } from '@/components/admin/UserBehaviorAnalytics';
import { AdminBreadcrumb } from '@/components/AdminBreadcrumb';
import { useSEO } from '@/hooks/useSEO';

export default function AdminBehaviorPage() {
  useSEO({
    title: 'User Behavior Analytics - Admin Tools',
    description: 'Analyze user behavior patterns, feature usage, and engagement metrics for the chess application.',
    canonical: '/admin/behavior',
    robots: 'noindex, nofollow'
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-purple-950/95 to-slate-950">
      <AdminBreadcrumb 
        title="User Behavior Analytics" 
        description="Analyze user behavior patterns, feature usage, and engagement metrics for the chess application."
      />
      
      <div className="max-w-7xl mx-auto p-8">
        <UserBehaviorAnalytics />
      </div>
    </div>
  );
}